module.exports = __webpack_public_path__ + "img/community-photo.624873ec.png";